import { BasicInformationFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { Employee } from 'modules/core/hooks/useCurrentSession'
import { fromCents } from 'modules/core/lib/formatCurrencyUtils'

export const getBasicInformationDefaultValues = (
  employee: Employee,
  data?: BasicInformationFragment | null
) => {
  // Map session employee to match EmployeeForSelectFragmentNoAccess type
  const mapSessionEmployee = (sessionEmployee: Employee): EmployeeForSelectFragmentNoAccess => ({
    id: sessionEmployee?.id ?? '0',
    firstName: sessionEmployee?.firstName || '',
    fullName: (sessionEmployee?.firstName || '') + ' ' + (sessionEmployee?.lastName || ''),
    lastName: sessionEmployee?.lastName || '',
    preferredName: sessionEmployee?.preferredName || null,
    access: { avatar: null },
  })

  return {
    amount: data?.amount ? fromCents(parseInt(data.amount)) : 0,
    currency: data?.currency || employee?.legalEntity?.currency || 'EUR',
    employee: data?.owner?.employeeName || mapSessionEmployee(employee),
    effectiveOn: data?.effectiveOn
      ? moment(data.effectiveOn).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD'),
    documentNumber: data?.expense?.documentNumber ?? '',
  }
}
